import React from 'react';
import { TrendingUp, Package, Truck, BadgeCheck } from 'lucide-react';
import { containerWide, sectionHeading, sectionSpacing } from '../styles/ui';

const Wholesale = () => {
  const benefits = [
    {
      icon: TrendingUp,
      title: 'Competitive Pricing',
      description: 'Get the best wholesale rates for bulk orders with flexible payment terms',
      tone: 'mint',
    },
    {
      icon: Package,
      title: 'Bulk Supply',
      description: 'Regular supply of fresh products in large quantities to meet your business needs',
      tone: 'cream',
    },
    {
      icon: Truck,
      title: 'Timely Delivery',
      description: 'Reliable and on-time delivery to keep your business running smoothly',
      tone: 'sage',
    },
    {
      icon: BadgeCheck,
      title: 'Quality Assured',
      description: 'Consistent quality across all orders with strict quality control measures',
      tone: 'white',
    }
  ];

  return (
    <section id="wholesale" className={`${sectionSpacing} bg-gradient-mesh bg-gradient-to-br from-emerald-50 via-canvas to-accent-50/40 relative overflow-hidden`}>
      <div className={`${containerWide} relative`}>
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold tracking-widest uppercase text-accent-600 mb-3">
            Partner With Us
          </span>
          <h2 className={`${sectionHeading} mb-4`}>Wholesale Partnership</h2>
          <p className="text-lg text-ink-secondary max-w-2xl mx-auto">
            Partner with us for bulk supply of fresh fish, dairy, meat, and grocery essentials at competitive wholesale prices
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="bg-white/90 backdrop-blur-sm p-6 rounded-3xl shadow-card hover:shadow-lifted hover:-translate-y-1 transition-all duration-300 border border-emerald-100"
              >
                <div className="w-14 h-14 bg-gradient-primary rounded-2xl flex items-center justify-center mb-4 shadow-glow-teal">
                  <Icon className="text-white" size={28} />
                </div>
                <h3 className="text-xl font-bold text-emerald-950 mb-2">{benefit.title}</h3>
                <p className="text-ink-secondary text-sm leading-relaxed">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Wholesale;
